import { useEffect, useState } from "react";
import { apiFetch } from "@/utils/api";

export interface PartOption {
  id: string;
  part_name: string;
  part_number: string;
  on_hand: number;
}

export interface LocationOption {
  id: string;
  name: string;
}

export interface CustomerOption {
  id: string;
  name: string;
}

export function usePartsAndLocations() {
  const [parts, setParts] = useState<PartOption[]>([]);
  const [locations, setLocations] = useState<LocationOption[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    const [partsData, locData] = await Promise.all([
      apiFetch<{ parts: PartOption[] }>("/parts"),
      apiFetch<{ locations: LocationOption[] }>("/locations"),
    ]);
    setParts(partsData.parts);
    setLocations(locData.locations);
  };

  useEffect(() => {
    reload()
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { parts, locations, loading, reload };
}

export function useCustomers() {
  const [customers, setCustomers] = useState<CustomerOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiFetch<{ customers: CustomerOption[] }>("/customers");
        setCustomers(data.customers);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { customers, loading };
}
